import { useIntl } from 'react-intl'
import {
  FilterFooter,
  FilterListbox,
  FilterOptionRadio,
  FilterPopover,
  type UseFilterStateReturn,
} from '@vtex/admin-ui'
import { BaseFilter } from '@/components/filters/BaseFilter/BaseFilter'
import { useFilter } from '@/components/filters/hooks/useFilter'

function FilterStatusPopover<T = boolean>(props: FilterStatusProps<T>) {
  const { state } = props

  const { formatMessage } = useIntl()

  return (
    <FilterPopover state={state}>
      <FilterListbox>
        <FilterOptionRadio
          id="published"
          value={true}
          label={formatMessage({
            id: 'admin/admin.catalog.status-filter-active-label',
            defaultMessage: 'Active',
          })}
        />
        <FilterOptionRadio
          id="inactive"
          value={false}
          label={formatMessage({
            id: 'admin/admin.catalog.inactive-status-label',
            defaultMessage: 'Inactive',
          })}
        />
      </FilterListbox>
      <FilterFooter />
    </FilterPopover>
  )
}

export type SerializedData = '' | 'true' | 'false'

export function FilterStatus(props: { name: string }) {
  const { formatMessage } = useIntl()

  return (
    <BaseFilter
      disclosureMessage={formatMessage({
        id: 'admin/admin.catalog.status-filter-label',
        defaultMessage: 'Status',
      })}
      FilterPopoverComponent={FilterStatusPopover}
      filterName={props.name}
      useFilterState={useFilter}
      toSerializableData={(data) =>
        String(data.appliedItem?.value ?? '') as SerializedData
      }
    />
  )
}

interface FilterStatusProps<T> {
  state: UseFilterStateReturn<T>
}
